(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["km-category-index"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-km-cat]').forEach(function (root) {
    var thumb = root.querySelector('.km-cat__thumb');
    if (!thumb) return;
    root.querySelectorAll('.km-cat__row').forEach(function (row) {
      var img = row.getAttribute('data-img');
      if (!img) return;
      row.addEventListener('mousemove', function (e) { thumb.style.left = e.clientX + 'px'; thumb.style.top = e.clientY + 'px'; });
      row.addEventListener('mouseenter', function () { thumb.style.backgroundImage = 'url(' + img + ')'; thumb.classList.add('is-visible'); });
      row.addEventListener('mouseleave', function () { thumb.classList.remove('is-visible'); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["km-product-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-km-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-km-rail-track]');
    var nav = rail.querySelector('[data-km-rail-nav]');
    var prev = rail.querySelector('[data-km-rail-prev]');
    var next = rail.querySelector('[data-km-rail-next]');
    if (!track) return;
    function step() {
      var card = track.querySelector('.km-rail__card');
      var gap = parseInt(getComputedStyle(track).columnGap) || 18;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }
    function update() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      if (nav) nav.style.display = overflow ? '' : 'none';
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["km-promo-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.kmInit) return;
      root.dataset.kmInit = '1';
      var vp = root.querySelector('[data-viewport]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      if (!vp) return;
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
      var pauseBtn = root.querySelector('[data-pause]');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mobileMq = window.matchMedia('(max-width: 749px)');
      var loop = root.dataset.loop === 'true';
      var autoplay = root.dataset.autoplay === 'true' && !reduced && slides.length > 1;
      var interval = parseInt(root.dataset.interval, 10) || 6000;
      var timer = null, paused = false, hover = false, current = 0, inView = true;

      /* Video-Slides: sichtbares <video> je Slide (Desktop/Mobil), nur aktiver Slide spielt. */
      function videoOf(slide) {
        if (!slide.hasAttribute('data-video-slide')) return null;
        var d = slide.querySelector('.km-promoc__vid--d'), m = slide.querySelector('.km-promoc__vid--m');
        if (m && mobileMq.matches && slide.querySelector('.km-promoc__vl-full')) return m;
        return d || m;
      }
      function playVideo(slide) {
        if (reduced) return;
        var v = videoOf(slide); if (!v) return;
        slides.forEach(function (s) { var o = videoOf(s); if (o && o !== v) { o.pause(); } });
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      function pauseVideos() { slides.forEach(function (s) { var v = videoOf(s); if (v) v.pause(); }); }
      function delayFor(i) {
        var s = slides[i]; var v = videoOf(s);
        if (v && s.dataset.videoWait === 'true' && isFinite(v.duration) && v.duration > 0 && !reduced) {
          return Math.max(interval, (v.duration - v.currentTime) * 1000 + 200);
        }
        return interval;
      }

      function goTo(i, behavior) {
        if (loop) { i = (i + slides.length) % slides.length; } else { i = Math.max(0, Math.min(slides.length - 1, i)); }
        vp.scrollTo({ left: slides[i].offsetLeft - vp.offsetLeft, behavior: behavior || (reduced ? 'auto' : 'smooth') });
      }
      function update() {
        var w = vp.clientWidth || 1;
        var i = Math.round(vp.scrollLeft / w);
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (i === current) return;
        current = i;
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (!loop) { if (prev) prev.disabled = i === 0; if (next) next.disabled = i === slides.length - 1; }
        if (inView) playVideo(slides[i]);
        restart();
      }
      function start() {
        if (!autoplay || paused || hover || timer || !inView) return;
        timer = setTimeout(function () { timer = null; goTo(current + 1); start(); }, delayFor(current));
      }
      function stop() { if (timer) { clearTimeout(timer); timer = null; } }
      function restart() { stop(); start(); }

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.dataset.dot, 10)); }); });
      vp.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });
      var raf = null;
      vp.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; update(); }); }, { passive: true });
      root.addEventListener('mouseenter', function () { hover = true; stop(); });
      root.addEventListener('mouseleave', function () { hover = false; start(); });
      root.addEventListener('focusin', function () { hover = true; stop(); });
      root.addEventListener('focusout', function () { hover = false; start(); });
      if (pauseBtn) pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Automatischen Wechsel fortsetzen' : 'Automatischen Wechsel anhalten');
        paused ? stop() : start();
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); pauseVideos(); } else { if (inView) playVideo(slides[current]); start(); }
      });
      /* Video-Metadaten: sobald die Dauer bekannt ist, Wartezeit neu berechnen. */
      slides.forEach(function (s) {
        var v = videoOf(s); if (!v) return;
        v.addEventListener('loadedmetadata', function () { if (slides[current] === s) restart(); });
      });
      /* Nur spielen, wenn das Karussell im Viewport ist. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            inView = e.isIntersecting;
            if (inView) { playVideo(slides[current]); start(); } else { stop(); pauseVideos(); }
          });
        }, { threshold: 0.25 }).observe(root);
      } else {
        playVideo(slides[current]);
      }
      if (mobileMq.addEventListener) mobileMq.addEventListener('change', function () { pauseVideos(); if (inView) playVideo(slides[current]); });
      if (!loop) { if (prev) prev.disabled = true; }
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === 0 ? 'true' : 'false'); });
      start();
    }
    function scan() { document.querySelectorAll('[data-km-promoc]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-km-promoc]'); if (root) { delete root.dataset.kmInit; init(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
